import axios from 'axios';

class AuthService {
  constructor() {
    this.token = localStorage.getItem('token');
    this.user = JSON.parse(localStorage.getItem('user') || 'null');
    this.interceptorId = null;
    this.setupInterceptors();
  }

  setupInterceptors() {
    // Nettoyer l'ancien intercepteur s'il existe
    if (this.interceptorId !== null) {
      axios.interceptors.request.eject(this.interceptorId);
    }

    // Intercepteur pour ajouter le token aux requêtes
    this.interceptorId = axios.interceptors.request.use(
      (config) => {
        // Récupérer le token le plus récent
        const currentToken = localStorage.getItem('token');
        if (currentToken) {
          config.headers.Authorization = `Bearer ${currentToken}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // Intercepteur pour gérer les erreurs d'authentification
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          // Ne pas déclencher de déconnexion automatique pour les erreurs de login
          if (!error.config?.url?.includes('/auth/login')) {
            this.logout();
            window.location.reload();
          }
        }
        return Promise.reject(error);
      }
    );
  }

  async login(username, password) {
    try {
      const response = await axios.post('/api/auth/login', {
        username,
        password
      });

      const { token, user } = response.data;

      this.token = token;
      this.user = user;

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));

      // Reconfigurer les intercepteurs avec le nouveau token
      this.setupInterceptors();

      return { success: true, user };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Erreur de connexion'
      };
    }
  }

  logout() {
    this.token = null;
    this.user = null;
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }

  isAuthenticated() {
    return !!this.token && !!this.user;
  }

  getUser() {
    return this.user;
  }

  getToken() {
    return this.token;
  }
}

export default new AuthService();